<template>
  <q-page padding>
    <PageHeader
      title="Termos de Uso"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold text-body"
    >
      <div class="col-8">
        <div class="q-ml-sm">Título</div>
        <q-input dense outlined v-model="dados.titulo" />
      </div>
      <div class="col-3">
        <p></p>
        <q-btn
          class="q-mt-sm"
          label="Adicionar Termo"
          color="positive"
          no-caps
          icon="add"
          @click="adicionarTermoDeUso()"
        />
      </div>
    </div>
    <div class="row q-mt-md text-brand-5 text-weight-bold text-body">
      <div style="width: 100%">
        <div class="q-ml-sm">Descrição</div>
        <q-input type="textarea" dense outlined v-model="dados.descricao" />
      </div>
    </div>
    <div class="row col-12 justify-between">
      <div>
        <span
          style="font-size: 18px"
          class="row col-12 text-brand-5 text-weight-bold q-ml-md q-mt-xl q-mb-md"
        >
          Lista de Termos
        </span>
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-lg"
          outlined
          color="positive"
          label="Sincronizar Termos"
          no-caps
          icon="sync"
          @click="sincronizarTermos()"
        />
      </div>
    </div>
    <div>
      <q-table
        :columns="columns"
        :rows="listaTermos"
        table-header-class="bg-accent text-weight-bold"
        flat
        dense
        hide-bottom
        class="tabela-tamanho-fixo"
        hide-pagination
        virtual-scroll
        :rows-per-page-options="[0]"
      >
        <template v-slot:body-cell-titulo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.titulo }}
          </q-td>
        </template>
        <template v-slot:body-cell-detalhe="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'detalhestermosdeuso',
                params: { termoId: props.row.termoDeUsoId },
              }"
            >
              <q-btn color="blue-6" round icon="article" size="sm" />
            </router-link>
          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { useStore } from "vuex";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: { PageHeader },
  setup() {
    const columns = [
      {
        name: "titulo",
        label: "Título",
        align: "left",
        field: "titulo",
      },
      {
        name: "detalhe",
        align: "center",
        label: "Detalhes",
      },
    ];
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();

    let listaTermos = ref();
    const dados = ref({
      titulo: "",
      descricao: "",
    });

    const listarTermos = async () => {
      let resposta = await store.dispatch("office/listarTermosDeUso");
      listaTermos.value = resposta.data.resultado.dados;
    };

    const adicionarTermoDeUso = async () => {
      if (dados.value.titulo == "" || dados.value.descricao == "") {
        quasar.notify({
          message: "Preencha todos os campos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("office/adicionarTermoDeUso", {
          titulo: dados.value.titulo,
          descricao: dados.value.descricao,
        });
        listarTermos();
        quasar.notify({
          message: "Termos de uso adicionado",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        reset();
      } catch (error) {
        quasar.notify({
          message: "Erro ao adicionar termos de uso",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        console.log(error);
      }
    };

    const sincronizarTermos = async () => {
      try {
        await store.dispatch("office/sincronizarTermos");
        quasar.notify({
          message: "Termos sincronizados com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao sincronizar termos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      }
    };

    const reset = () => {
      dados.value.titulo = "";
      dados.value.descricao = "";
    };

    const detalharTermo = (termoId) => {
      router.push({ name: "detalhestermosdeuso", params: { termoId } });
    };

    onMounted(listarTermos);

    return {
      listaTermos,
      listarTermos,
      adicionarTermoDeUso,
      dados,
      columns,
      detalharTermo,
      reset,
      sincronizarTermos,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
